<template lang="pug">
.container.share.d-flex.flex-column(v-if="fetched")
  .container-share.m-auto
    .title.d-flex.align-items-center.justify-content-center
      svg(width="28" height="30" viewBox="0 0 28 30" fill="none" xmlns="http://www.w3.org/2000/svg")
        path(d="M20.6607 29.1392C20.4607 29.1392 20.2607 29.1392 20.0607 29.1392C19.2607 28.9392 18.6607 28.5392 18.2607 27.9392L12.4607 20.1392H3.26074C1.66074 20.1392 0.260742 18.7392 0.260742 17.1392C0.260742 16.1392 0.860742 15.1392 1.66074 14.7392L23.2607 1.33919C23.8607 0.939194 24.6607 0.739194 25.4607 0.939194C26.2607 1.13919 26.8607 1.53919 27.2607 2.33919C27.6607 2.93919 27.8607 3.73919 27.6607 4.53919L23.4607 26.9392C23.2607 27.7392 22.8607 28.3392 22.2607 28.7392C21.8607 28.9392 21.2607 29.1392 20.6607 29.1392ZM24.8607 2.73919C24.6607 2.73919 24.4607 2.73919 24.4607 2.93919L2.86074 16.3392C2.46074 16.5392 2.26074 16.9392 2.26074 17.1392C2.26074 17.7392 2.66074 18.1392 3.26074 18.1392H13.0607C13.4607 18.1392 13.6607 18.3392 13.8607 18.5392L19.8607 26.7392C20.0607 26.9392 20.2607 27.1392 20.4607 27.1392C20.6607 27.1392 20.8607 27.1392 21.2607 26.9392C21.4607 26.7392 21.6607 26.5392 21.6607 26.3392L25.8607 3.93919C25.8607 3.73919 25.8607 3.53919 25.6607 3.33919C25.4607 3.13919 25.2607 2.93919 25.0607 2.93919C25.0607 2.73919 24.8607 2.73919 24.8607 2.73919Z" fill="#3C67FF")
        path(d="M12.0605 28.1391C10.4605 28.1391 9.06055 26.7391 9.06055 25.1391V19.1391C9.06055 18.5391 9.46055 18.1391 10.0605 18.1391H13.0605C13.4605 18.1391 13.6605 18.3391 13.8605 18.5391L17.6605 23.7391C17.8605 23.9391 17.8605 24.1391 17.8605 24.5391C17.8605 24.9391 17.6605 25.1391 17.4605 25.1391L13.6605 27.7391C13.2605 27.9391 12.6605 28.1391 12.0605 28.1391ZM11.0605 20.1391V25.1391C11.0605 25.9391 12.0605 26.3391 12.6605 25.9391L15.4605 23.9391L12.6605 20.1391H11.0605Z" fill="#3C67FF")
        path(d="M13.061 20.1394C12.861 20.1394 12.661 20.1394 12.461 19.9394C12.061 19.5394 11.861 18.9394 12.261 18.5394L25.1376 1.66256C25.5376 1.26256 26.1376 1.06256 26.5376 1.46256C26.9376 1.86256 27.1376 2.46256 26.7376 2.86256L13.861 19.7394C13.661 19.9394 13.261 20.1394 13.061 20.1394Z" fill="#3C67FF")
      h1.typo-heading32.typo-semi-150.text-mono3.ml-1 {{ $t("template.shared.title") }}
    .row.share-body.mt-5
      .col-md-6.d-flex.align-items-center
        .px-half
          img(width="100%" height="auto" src="../assets/share.png")
      .col-md-6
        .px-half
          p.typo-heading24.typo-semi.text-light-high {{ title }}
          p(class="mt-half typo-paragraph12 typo-medium text-light-low" v-html="$t('template.shared.by', { author: author })")
          p.typo-paragraph14.typo-regular-150.text-light-low.mt-1 {{ description }}
          .templates.mt-5(v-if="(templates && templates.length)")
            p.typo-heading16.typo-medium-150 {{ (templates && templates.length) || 0 }} {{ $tc("generals.template", templates.length) }}
            .items.mt-2
              template(v-for="item in templates")
                .item.d-flex.align-items-center.mb-1(:key="'_-template' + item.id")
                  svg(width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg")
                    path(fill-rule="evenodd" clip-rule="evenodd" d="M11.5714 0.289237C11.8259 0.467395 11.8878 0.818132 11.7097 1.07263L4.66841 11.1311C4.16697 11.8509 3.17656 12.0289 2.45643 11.5277C2.31644 11.4303 2.19305 11.311 2.09099 11.1743L0.300054 8.78671C0.113643 8.5382 0.163988 8.18562 0.412505 7.99921C0.661021 7.8128 1.0136 7.86314 1.20001 8.11166L2.9922 10.5009C3.02202 10.5409 3.0581 10.5758 3.09905 10.6043C3.3094 10.7507 3.59861 10.6988 3.74501 10.4885L3.7459 10.4872L10.788 0.427466C10.9662 0.172967 11.3169 0.11108 11.5714 0.289237Z" fill="#3C67FF")
                  p.typo-paragraph16.typo-regular-150.text-mono3.ml-1 {{ item.name }}
          .blocks.mt-2(v-if="(blocks && blocks.length)")
            p.typo-heading16.typo-medium-150 {{ (blocks && blocks.length) || 0 }} {{ $tc("generals.block", blocks.length) }}:
            .items.mt-2
              template(v-for="item in blocks")
                .item.d-flex.align-items-center.mb-1(:key="'__block' + item.id")
                  svg(width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg")
                    path(fill-rule="evenodd" clip-rule="evenodd" d="M11.5714 0.289237C11.8259 0.467395 11.8878 0.818132 11.7097 1.07263L4.66841 11.1311C4.16697 11.8509 3.17656 12.0289 2.45643 11.5277C2.31644 11.4303 2.19305 11.311 2.09099 11.1743L0.300054 8.78671C0.113643 8.5382 0.163988 8.18562 0.412505 7.99921C0.661021 7.8128 1.0136 7.86314 1.20001 8.11166L2.9922 10.5009C3.02202 10.5409 3.0581 10.5758 3.09905 10.6043C3.3094 10.7507 3.59861 10.6988 3.74501 10.4885L3.7459 10.4872L10.788 0.427466C10.9662 0.172967 11.3169 0.11108 11.5714 0.289237Z" fill="#3C67FF")
                  p.typo-paragraph16.typo-regular-150.text-mono3.ml-1 {{ item.name }}
          .login.mt-5
            p.typo-paragraph15.typo-regular-150.mb-1 {{ $t("template.shared.enterDomain") }}
            form(:action="formSubmitPath" @submit.prevent="onSubmit" ref="formSubmit")
              .d-flex.align-items-center
                input(name="ref" type="hidden" :value="ref" v-if="ref && ref.length")
                input.shop-input.mr-2(type='text' name="shop" :placeholder="$t('template.shared.enterDomainHolder')" v-model="shopDomain")
                button.btn.btn-default.btn-primary(type="submit") {{ $t("agency.signin") }}
              .d-flex.align-items-center
                div.error-message(v-if="error") {{ error }}
  .mt-auto
    Disclaimer
</template>

<script>
import { serverDomain } from "@/config";
import { Api, ApiUrl } from "@/services";
import { Disclaimer } from "../components";
export default {
  name: "LibraryShare",
  components: {
    Disclaimer
  },
  data() {
    return {
      // router param
      token: null,
      // received
      templates: [],
      blocks: [],
      author: "",
      created_at: "",
      ref: null,
      title: "",
      description: "",
      code: "",
      // user input
      shopDomain: "",

      fetched: false,
      error: ""
    };
  },
  computed: {
    formSubmitPath() {
      return `${serverDomain()}/login`;
    }
  },
  created() {
    this.initCheck();
  },
  methods: {
    async onSubmit(e) {
      this.error = "";
      e.preventDefault();
      e.stopPropagation();
      const regex = /^(?:https?:\/\/)?([a-z0-9-]+\.myshopify\.com)/;
      const match = this.shopDomain.match(regex);
      if (match) {
        const shopifyDomain = match[1];
        try {
          const res = await Api.base.post(ApiUrl.base.template.checkDomainShareLibrary, {
            code: this.code,
            shopify_domain: shopifyDomain
          });
          if (res.data && res.data.success) {
            this.setStorage();
            window.location.href = `https://admin.shopify.com/store/${shopifyDomain.replace(".myshopify.com", "")}/apps/${process.env.VUE_APP_GEMPAGES_APP_ID}/app/dashboard?code=${this.code}`;
            return true;
          } else {
            throw "Something went wrong!";
          }
        } catch (error) {
          this.error = error.response.data.message ?? "Something went wrong!";
          return false;
        }
      } else {
        alert("You must enter a valid shopify domain");
        return false;
      }
    },
    setStorage() {
      try {
        const library = {
          templates: this.templates,
          blocks: this.blocks,
          title: this.title,
          author: this.author,
          created_at: this.created_at,
          description: this.description,
          code: this.code
        };
        localStorage.setItem("sharedLibrary", JSON.stringify(library));
      } catch (exception) {
        // eslint-disable-next-line no-console
        console.error(exception);
      }
    },
    initCheck() {
      let token = this.$route.params.id;
      if (!token || !token.length) {
        // redirect to error page
        this.$router.replace({ name: "ShareError", params: { type: "token-empty" } });
      }
      this.token = token;
      Api.base
        .get(ApiUrl.base.shareLibrary(token))
        .then(res => {
          if (res && res.data && res.data.status == "success") {
            this.templates = res.data.data.templates;
            this.blocks = res.data.data.blocks;
            this.title = res.data.data.title;
            this.author = res.data.data.author;
            this.created_at = res.data.data.created_at;
            this.description = res.data.data.description;
            this.code = res.data.data.code;
            this.fetched = true;
          } else {
            this.$router.replace({ name: "ShareError", params: { type: res.data.message } });
          }
        })
        .catch(err => {
          this.$router.replace({ name: "ShareError", params: { type: (err.response && err.response.data && err.response.data.data.message) || "network" } });
        });
    }
  }
};
</script>

<style lang="scss" scoped>
.share {
  min-height: calc(100vh - 65px);
  padding: 50px 0 24px 0;
  .share-body {
    margin-bottom: 50px;
    .shop-input {
      min-width: 360px;
    }
  }
}
.error-message {
  color: red;
  padding-top: 5px;
  font-style: italic;
}
</style>
